import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getUserSessionRequested } from '../actions';

@connect(undefined, { getUserSessionRequested })
export default class App extends Component {
  // componentWillMount() {
  //   this.props.getUserSessionRequested();
  // }

  render() {
    return (
      <div>
        { this.props.children }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/App.jsx